import styled from 'styled-components'
import Button from 'src/comps/Atom/Buttons/Button'

const SecondaryButton = styled(Button).attrs(props => ({
  ...props,
  backgroundColor: 'grey8',
  borderColor: 'grey2',
  color: 'grey2',
}))<typeof Button>``

export default SecondaryButton
